<template>
  <div class="popup-box">
    <div class="popup">
      <div class="popTitle">{{detail.content.title}}
        <span class="tagName-ts" v-if=" detail.content.pointTypeName && detail.expandData1 === '3'"
              :class="{y:detail.content.pointTypeName === '外摆位',g:detail.content.pointTypeName === '特色集市、夜市',x:detail.content.pointTypeName === '限时步行街'}">
                      {{ detail.content.pointTypeName }}
                     </span></div>
      <div class="detail-content">
        <div class="img-block" v-if="detail.content.images && detail.content.images.length">
          <el-carousel height="200px" :autoplay="false">
            <el-carousel-item v-for="item in detail.content.images" :key="item.id">
              <img :src="setImages(item)" alt="" style="width: 100%;height: 100%;">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="img-block" v-else>
          <img :src="img2" alt="" v-if="detail.content.title === '大学路商业街'">
          <img :src="img5" alt="" v-else-if="detail.content.title === '迪士尼小镇'">
          <img :src="img6" alt="" v-else-if="detail.content.title === '锦江乐园夜市'">
          <img :src="img7" alt="" v-else-if="detail.content.title === '首尔夜市景'">
          <img :src="img3" alt="" v-else-if="detail.content.title === '外滩源集'">
          <img :src="img4" alt="" v-else-if="detail.content.title === '安义路夜巷'">
          <img :src="img1" alt="" v-else-if="detail.content.title === 'BFC外滩枫径'">
          <img :src="setImage(detail.content.pointTypeName)" alt="" v-else>
        </div>
        <div class="font-block" >
          <div class="address-item bg-item">
            <div style="flex: 1;display: flex;line-height: 1em">
              <img src="../assets/dw.png" style="margin: auto;width: 16px;margin-right:3px;vertical-align: middle" alt="">
              <span style="display: inline-block;margin: auto;flex: 1;white-space:normal; word-break:break-all; max-width: 295px;">
                {{detail.content.pointAddress}}
              </span>
            </div>
            <div class="btn-block">
              <div @click="toDh">
                <img src="../assets/dh-icon.png" >
                导航
              </div>
            </div>
          </div>
          <div class="bg-item">
            <div>
              开放时间：<br>{{detail.content.businessTime}}
            </div>
            <div>
              售卖类目：{{detail.content.businessCategoryName}}
            </div>
            <div>
              摊位数量：{{detail.content.boothNum}}
            </div>
            <span class="tagName"
                  :class="{y:item === '梨'||item === '黄桃',r:item === '火龙果',z:item === '葡萄',g:item === '西瓜'||item === '瓜果蔬菜'}"
                  v-for="item in detail.tagName">
               {{item}}
             </span>
          </div>

          <div class="bg-item">
            <el-button size="small" type="primary" plain @click="rateFlag = true">
              评分
            </el-button>
            <el-button size="small" type="primary" plain @click="mesFlag = true">
              留言
            </el-button>
          </div>
        </div>

      </div>
      <div>

      </div>
      <el-dialog title="评分"
                 append-to-body
                 :visible.sync="rateFlag"
                 width="400px">
        <el-rate
            v-model="value2"
            show-score
            :colors="colors">
        </el-rate>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveRate">保存</el-button>
        </span>
      </el-dialog>
      <el-dialog title="留言"
                 append-to-body
                 :visible.sync="mesFlag"
                 width="500px">
        <el-input
            type="textarea"
            v-model="value3"
            :autosize="{ minRows: 4}"
            show-score
            :colors="colors">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveMessage">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import utils from "@/common/utils";
// const imgList = window.webConfig.imgList;
import img1 from '@/assets/mockImages/bfc.png'
import img2 from '@/assets/mockImages/daxuelu.png'
import img3 from '@/assets/mockImages/waitan.png'
import img4 from '@/assets/mockImages/anyilu.png'
import img5 from '@/assets/mockImages/dishini.png'
import img6 from '@/assets/mockImages/jinjiang.png'
import img7 from '@/assets/mockImages/shouer.png'
export default {
  data() {
    return {
      img1,
      img2,
      img3,
      img4,
      img5,
      img6,
      img7,
      overlay: null,
      activeName:"first",
      // imgList,
      switchFlag:false,
      value3:"",
      mesFlag:false,
      rateFlag:false,
      showItem:false,
      infoWindow: null,
      value2: 5,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      zrjz:false,
      isInfo: true,
      onlineNum:"",
      itemList:[],
    };
  },
  props:["detail"],
  computed:{
    itemListFilter(){
      if (this.switchFlag){
        return this.itemList
      }else{
        return this.itemList.filter(i=>i.expandData1 === "1")
      }
    }
  },
  methods: {
    // 设置图片
    setImage(data) {
      return utils.setPointTypeImage(data)
    },
    setImages(data) {
      // let imageUrl = ''
      // if(data && data.images && data.images[0]?.filePath) {
      //   imageUrl = window.webConfig.superviseUrl +data.images[0].filePath + '?&width=200'
      // }else if(data && data.images && data.images[0]?.content) {
      //   imageUrl = data.images[0].content
      // }else {
      //   imageUrl = ''
      // }
      // return imageUrl
      return window.webConfig.superviseUrl +data.filePath + '?&width=200'
    },
    saveRate(){
      let data = {
        evaluate: this.value2,
      }
      axios.post(window.webConfig.apiPath + "/GeneralBusiness/Add",{
        type: 'evaluate', //type
        keyWord:this.value2,
        relationId: this.detail.id,
        content: JSON.stringify(data)
      },
          {
            headers:{
              token:utils.getToken({type:'evaluate'}).token,
              timestamp:utils.getToken({type:'evaluate'}).timestamp,
            }
          }
      ).then(res=>{
        // 评分埋点
        utils.setExecute({
          "type": "shangHaiTanExecute",//类型
          "PageId": "ShangHaiTanPointsDetail",//页面ID
          "EventType": "evaluateClick",//事件类型
          "EventName": "评价-点击",//事件名称
          ObjId:this.detail.id, // 对象ID
          ObjName:this.detail.title, // 对象名称
          clientType:'screen-PC',
        })
        this.$message.success("保存成功")
        this.rateFlag = false
      }).catch(()=>{
        this.rateFlag = false
      })
    },
    saveMessage(){
      let data = {
        evaluate: this.value3,
      }
      axios.post(window.webConfig.apiPath + "/GeneralBusiness/Add",{
        type: 'message', //type
        keyWord:this.value3,
        relationId: this.detail.id,
        content: JSON.stringify(data)
      },
          {
            headers:{
              token:utils.getToken({type:'message'}).token,
              timestamp:utils.getToken({type:'message'}).timestamp,
            }
          }
      ).then(res=>{
        // 留言埋点
        utils.setExecute({
          "type": "shangHaiTanExecute",//类型
          "PageId": "ShangHaiTanPointsDetail",//页面ID
          "EventType": "messageClick",//事件类型
          "EventName": "留言-点击",//事件名称
          ObjId:this.detail.id, // 对象ID
          ObjName:this.detail.title, // 对象名称
          clientType:'screen-PC',
        })
        this.$message.success("保存成功")
        this.mesFlag = false
      }).catch(()=>{
        this.mesFlag = false
      })
    },
    toDh(){
      window.open(`https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.detail.content.latlng};title:${this.detail.content.title};addr:${this.detail.content.pointAddress}&referer=地址转化`)
    },
    getChild(){
      axios.post(window.webConfig.apiPath + "/GeneralBusiness/GetPageList",{
        title: "", // 点位名称
        expandData1:  '', // 点位类型 string ’1‘疏导点 2管控点 “3”特色点
        unit: "",// 单位
        relationId:this.detail.id,
        type: 'businessStallMock2', //type
        "pageSize": 999,
      }).then(res=>{
        this.itemList = res.data.resMap.data.map(i=>{
          return {...i,content:JSON.parse(i.content)}
        })
        this.onlineNum = this.itemList.filter(i=>i.expandData1 === "1").length
      })
    }
  },
  mounted() {
    // this.getChild()
  }
};
</script>

<style lang="less">
  .popup-box{
    width: 820px;
    text-align: left;
    font-size: 14px;
    line-height: 2em
  ;
    color: #666;
    .popTitle{
      color: #000;
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .detail-content{
      display: flex;
      .img-block{
        width: 300px;
        height: 200px;
        margin: 10px auto auto auto;
        img{
          height: 100%;
        }
      }
      .font-block{
        flex: 1;
        margin-left:10px;
        max-width: 400px;
        .bg-item{
          background: #f6f6f6;
          padding: 5px 10px;
          margin: 5px;
        }
        .address-item{
          display: flex
        }
      }
    }
    .tagName-ts{
      padding: 0 3px;
      line-height: 1.6em;
      display: inline-block;
      font-size: 12px;
      margin:2px 5px 0 0;
      background: rgb(0,127,255);
      border: 1px solid #007FFF;
      color: #fff;
      border-radius: 10px;
      &.y{
        background: rgb(255,149,0);
        border: 1px solid #FF9500;
      }
      &.g{
        background: rgba(43,217,130);
        border: 1px solid #2BD982;
      }
      &.x{
        background: rgba(49, 113, 234, 1);
        border: 1px solid rgba(49, 113, 234, 1);
      }
    }
    .tagName{
      padding: 0 3px;
      display: inline-block;
      margin:2px 0 0 5px;
      background: rgba(0,127,255,0.1);
      border: 1px solid #007FFF;
      color: #007FFF;
      font-size: 12px;
      line-height: 1.5em;
      border-radius: 10px;
      &.y{
        background: rgba(255,149,0,0.1);
        border: 1px solid #FF9500;
        color: #FF9642;
      }
      &.g{
        background: rgba(43,217,130,0.1);
        border: 1px solid #2BD982;
        color: #2BD982;
      }
      &.z{
        background: rgba(123,82,204,0.1);
        border: 1px solid #7B52CC;
        color: #7B52CC;
      }
      &.r{
        background: rgba(255,77,77,0.1);
        border: 1px solid #FF4D4D;
        color: #FF4141;
      }
    }
    .btn-block{
      display: flex;
      line-height: 30px;
      height: 30px;
      margin: auto;
      font-size: 14px;
      background: #007FFF;
      border-radius: 16px;
      padding: 0 10px;
      color: white;
      &>div{
        cursor: pointer;
      }
      img{
        width: 16px;
        vertical-align: middle;
      }
    }

    .el-tabs__content{
      height: 200px;
      overflow: auto;
    }
    .child-item{
      width: 300px;
      margin: auto;
      border-radius: 4px;
      border: 1px solid #ccc;
      position: relative;
      overflow: hidden;
      .tips{
        position: absolute;
        z-index: 1;
        right: -80px;
        padding: 0;
        transform: rotate(45deg);
        width: 200px;
        text-align: center;
        color: white;
        background: #27d527;
      }
      &>div{
        padding: 0 10px;
      }
    }
  }
</style>
